export default __webpack_public_path__ + "static/media/thumbnail-close-white.f0378f44.svg";